<template>
  <v-autocomplete
    id="municipio-select"
    v-model="filter.municipio"
    item-text="nome"
    item-name="municipioId"
    :items="municipios"
    label="Município"
    chips
    closable-chips
    placeholder="Município"
    @change="$emit('changeCity')"
    multiple
    :return-object="true"
    :disabled="disabled"
    clearable
  >
    <div
      style="display: flex; padding: 0 16px; cursor: pointer"
      slot="prepend-item"
      ripple
      @click="toggle"
    >
      <div style="margin-right: 32px">
        <v-icon :color="filter.municipio.length > 0 ? 'indigo darken-4' : ''">{{
          icon
        }}</v-icon>
      </div>
      <div>Todos</div>
    </div>
    <v-divider slot="prepend-item" class="mt-2" />

    <template v-slot:selection="{ item, index }">
      <v-chip v-bind="item" small v-if="index < maxDisplay">
        <span>{{ item.nome }}</span>
      </v-chip>
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{ filter.municipio.length - maxDisplay }} municípios)</span
      >
    </template>

    <template slot="no-data"> Nenhum Município retornado </template>
  </v-autocomplete>
</template>

<script>
import { cityAPI } from "@/modules/city";

export default {
  name: "AppCityComboboxMultiple",
  props: ["filter", "isMultiple", "disabled", "status"],
  mounted() {
    this.loadCities();
  },
  computed: {
    likesAll() {
      return this.filter.municipio.length === this.municipios.length;
    },
    likesSome() {
      return this.filter.municipio.length > 0 && !this.municipios;
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  watch: {
    status: {
      handler(val, oldVal) {
        if (val.length > 0) {
          this.municipios = this.municipios.filter((item) =>
            val.some((v) => v.statusId === item.statusId)
          );
        } else {
          this.municipios = this.allMunicipios;
        }
      },
      deep: true,
    },
  },
  methods: {
    loadCities() {
      cityAPI
        .listNames()
        .then((resp) => {
          this.municipios = resp.data;
          this.allMunicipios = resp.data;
        })
        .catch();
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.municipio = [];
          this.$emit("changeCity", this.filter.municipio);
        } else {
          this.filter.municipio = this.municipios.slice();
          this.$emit("changeCity", this.filter.municipio);
        }
      });
    },
  },
  data() {
    return {
      maxDisplay: 2,
      municipios: [],
      allMunicipios: [],
    };
  },
};
</script>
